// Controller Functions for the Phrase Mapper Table
import axiosInstances from '@/../../coreui/server/axiosInstances'
import check from "@/../../library/helper/propertyCheck.js"

const getPhrase = async function (key) {
    // Get the phrase mapper entry for a specific key
    let phraseTable = `/misc/dbops?c=auth_phrasemap&op=pipe`
    let pipe = [{
        $match: {
            key: key
        }
    }]
    let phraseSearch = await axiosInstances.loginServer.post(phraseTable, pipe)
    if (phraseSearch.length === 0) return null
    let phraseData = phraseSearch.data
    return phraseData[0]
}

const mapPhrase = (key, phrases, lang) => {
    if(check.isUndefined(key)) return ""
    var result = phrases.filter(obj => obj.key == key)
    if (!result || result.length < 1) return key
    return result[0][lang]
}

export default {
    getPhrase,
    mapPhrase
}